export default function TrackkPolicy() {
  return (
    <>
      {/* <Banner _data={data.banner} /> */}
      <div className="privacy-policy-container">
        <div className="nature1">
          <h1>Privacy Policy</h1>

          <p>
            Welcome to Trackk, a fleet management and user tracking solution
            designed for businesses to efficiently manage vehicles, deliveries,
            and personnel. We value your privacy and are committed to protecting
            your personal information. This Privacy Policy explains how we
            collect, use, and protect your data when you use our mobile
            application and related services.
          </p>

          <h2>1. Information We Collect</h2>

          <h4>A. Location Data</h4>
          <p>
            We collect location data to enable critical features such as
            real-time tracking, attendance marking, and delivery verification:
          </p>
          <ul>
            <li>
              <strong>Foreground Location Access:</strong> Required for
              attendance marking at specific locations.
            </li>
            <li>
              <strong>Background Location Access:</strong> Enables continuous
              tracking during check-in and check-out periods, which is vital for
              delivery operations.
            </li>
          </ul>
          <h4>B. Camera Access</h4>
          <p>We use your device's camera in the following scenarios:</p>
          <ul>
            <li>To scan vehicle license plates during driver login.</li>
            <li>
              To verify the driver-vehicle pairing before marking attendance.
            </li>
            <li>If scanning fails, a manual entry option is provided.</li>
          </ul>
          <h4>C. Gallery Access</h4>
          <p>Access to your device's photo library is required to:</p>
          <ul>
            <li>Upload scanned vehicle plate images.</li>
            <li>Assist in vehicle assignment verification.</li>
          </ul>
        </div>

        <h2>2. How We Use Your Information</h2>
        <p>
          We use the information collected through our app for the following
          purposes:
        </p>

        <ul>
          <li>
            <h4>Attendance Management via Geo-Fencing:</h4>
          </li>

          <ul>
            <li>
              Attendance can only be marked within designated geo-fenced areas
              when enabled by the admin.
            </li>
            <li>
              Even when geo-fencing is disabled, we log the location of
              attendance for operational transparency.
            </li>
          </ul>
          <li>
            <h4>Driver-Vehicle Verification:</h4>
          </li>

          <ul>
            <li>
              Ensures that only assigned vehicles are used by designated
              drivers.
            </li>
          </ul>
          <li>
            <h4>Live Location Tracking:</h4>
          </li>

          <ul>
            <li>
              Admins can monitor the real-time location of drivers and vehicles
              during working hours.
            </li>
          </ul>
          <li>
            <h4>Fleet and Order Management:</h4>
          </li>

          <ul>
            <li>
              Vehicle data and user movements are monitored to improve delivery
              operations.
            </li>
          </ul>
          <li>
            <h4>Leave & Ticket Management:</h4>
          </li>

          <ul>
            <li>
              Admins handle leave requests and issue operational tickets to
              users through the platform.
            </li>
          </ul>
        </ul>

        <h2>3. Data Retention & Security</h2>
        <p>
          We retain user and location data for the duration necessary to fulfill
          our business operations, ensure accountability, and comply with legal
          obligations. All data is stored securely and access is strictly
          controlled.
        </p>
        <h2>4. Changes to this Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes
          in technology, law, or our services. Updates will be posted on this
          page with the revised date.
        </p>
      </div>
    </>
  );
}
